export const DEFAULT_POINT_COUNT = parseFloat(
  import.meta.env.VITE_DEFAULT_POINT_COUNT,
)
export const DEFAULT_RESOLUTION = parseFloat(
  import.meta.env.VITE_DEFAULT_RESOLUTION,
)
export const DEFAULT_RENDER_INTERVAL_MS = parseFloat(
  import.meta.env.VITE_DEFAULT_RENDER_INTERVAL_MS,
)
export const DEFAULT_ZOOM_LEVEL = parseFloat(
  import.meta.env.VITE_DEFAULT_ZOOM_LEVEL,
)
export const DEFAULT_QUALITY = parseFloat(import.meta.env.VITE_DEFAULT_QUALITY)

export const DEFAULT_HIGH_QUALITY = parseFloat(
  import.meta.env.VITE_DEFAULT_HIGH_QUALITY,
)

export const DEFAULT_ULTRA_QUALITY = parseFloat(
  import.meta.env.VITE_DEFAULT_ULTRA_QUALITY,
)

export const DEFAULT_VARIATION_SHOW_DELAY_MS = parseFloat(
  import.meta.env.VITE_DEFAULT_VARIATION_SHOW_DELAY_MS,
)

export const DEFAULT_VARIATION_PREVIEW_POINT_COUNT = parseFloat(
  import.meta.env.VITE_DEFAULT_VARIATION_PREVIEW_POINT_COUNT,
)

export const DEFAULT_VARIATION_PREVIEW_RENDER_INTERVAL_MS = parseFloat(
  import.meta.env.VITE_DEFAULT_VARIATION_PREVIEW_RENDER_INTERVAL_MS,
)
